import React from 'react';
import './App.css';
import HelloScreen from './components/HelloScreen';

function App() {
	return (
		<div className="App">
			<HelloScreen />
		</div>
	);
}

export default App;
